'use client';

import getEnvValue from 'commons/getEnvValue';
import { POSTHOG_HOST } from '../../config/postHogConstants';

const postHogClientInitState = {
  initPromise: null,
  hasInitialized: false,
};

const getPostHogProjectToken = () =>
  getEnvValue('NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN') || '';

const buildInitConfig = ({
  bootstrap,
  shouldUseCookielessMode = false,
} = {}) => ({
  api_host: POSTHOG_HOST,
  bootstrap,
  disable_session_recording: true,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  cookieless_mode: shouldUseCookielessMode ? 'on_reject' : undefined,
  persistence: shouldUseCookielessMode ? 'memory' : 'localStorage+cookie',
  advanced_disable_flags: false,
  loaded: posthogInstance => {
    window.posthog = posthogInstance;
  },
});

export const isPostHogClientConfigured = () =>
  Boolean(getPostHogProjectToken());

export const ensurePostHogClientInitialized = async ({
  bootstrap,
  shouldUseCookielessMode = false,
} = {}) => {
  if (!isPostHogClientConfigured()) {
    return null;
  }

  if (postHogClientInitState.hasInitialized && window.posthog) {
    return window.posthog;
  }

  if (!postHogClientInitState.initPromise) {
    postHogClientInitState.initPromise = import('posthog-js').then(
      ({ default: posthog }) => {
        if (postHogClientInitState.hasInitialized && window.posthog) {
          return window.posthog;
        }

        posthog.init(
          getPostHogProjectToken(),
          buildInitConfig({ bootstrap, shouldUseCookielessMode })
        );
        postHogClientInitState.hasInitialized = true;
        return window.posthog || posthog;
      }
    );
  }

  return postHogClientInitState.initPromise;
};

export default ensurePostHogClientInitialized;
